/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 10/12/2021
 */

import {ClearanceLevelEnum} from "@shared/Profile/ClearanceLevelEnum.js";
import FilterableItem from "@shared/Filterable/FilterableItem.js";
import {AgeDateDisplayEnum} from "@shared/Genogram/AgeDateDisplayEnum";
import {
	getGenogramConnectionCategoryByEdgeData,
} from "@shared/Genogram/GenogramConnectionCategoryEnum";
import {
	syncNodeLabel
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/genogramUtils";

export default class GenogramItem extends FilterableItem {

	jsonData: Object = {}
	nodeGroups: Array = []
	clientId: string = null
	ageDateDisplay: AgeDateDisplayEnum = AgeDateDisplayEnum.FULL
	hideNoteDefault: boolean = false

	clearanceLevel: ClearanceLevelEnum = ClearanceLevelEnum.PHI;


	constructor(clientId: string = null) {
		super();
		this.setClientId(clientId)
	}

	setClientId(clientId: string = null) {
		this.clientId = clientId
		this.addSharedWithById([clientId])
	}

	getCurrentSchemaVersion(){
		return 3
	}

	migrateSchema(oldVersion, newVersion) {
		if(oldVersion < 2) {
			this.ageDateDisplay = AgeDateDisplayEnum.FULL
		}
		if(oldVersion < 3) {
			this.migrateConnectionCategories()
		}
		super.migrateSchema(oldVersion, newVersion);
	}

	migrateConnectionCategories() {
		let edges = this.jsonData?.elements?.edges || []
		for(let edge of edges){
			if(!edge?.data){
				continue
			}
			edge.data.connectionCategory = getGenogramConnectionCategoryByEdgeData(edge.data)
		}
	}

	iterateNodes(callback){
		let nodesArray = this.jsonData.elements?.nodes || []
		for(let node of nodesArray){
			callback(node.data)
		}
	}

	updateNodeLabelAll() {
		this.iterateNodes((nodeData) => {
			this.updateNodeLabel(nodeData)
		})
	}

	updateNodeLabel(nodeData) {
		syncNodeLabel(nodeData, {ageDateDisplay: this.ageDateDisplay})
	}
}
